import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, navigate, graphql, StaticQuery } from "gatsby";
import parse from "html-react-parser";
import ContentItem from "../components/content-item";
import { GatsbyImage } from "gatsby-plugin-image";

const Image = ({ image, caption, crop }) => {
  // TODO: srcset

  let maxWidthSmall = 320;
  let maxWidthMedium = 800;
  let maxWidthLarge = 1400;

  let relativeHeightSmall, relativeHeightMedium, relativeHeightLarge;
  if (crop === "3_2") {
    relativeHeightSmall = maxWidthSmall / (3 / 2);
    relativeHeightMedium = maxWidthMedium / (3 / 2);
    relativeHeightLarge = maxWidthLarge / (3 / 2);
  } else if (crop === "16_9") {
    relativeHeightSmall = maxWidthSmall / (16 / 9);
    relativeHeightMedium = maxWidthMedium / (16 / 9);
    relativeHeightLarge = maxWidthLarge / (16 / 9);
  } else {
    relativeHeightSmall = image.height / (image.width / maxWidthSmall);
    relativeHeightMedium = image.height / (image.width / maxWidthMedium);
    relativeHeightLarge = image.height / (image.width / maxWidthLarge);
  }
  relativeHeightSmall = Math.round(relativeHeightSmall);
  relativeHeightMedium = Math.round(relativeHeightMedium);
  relativeHeightLarge = Math.round(relativeHeightLarge);
  return (
    <picture className="img__container">
      <img
        sizes="(max-width: 1400px) 100vw, 1400px"
        srcSet={`
            ${image.url}?w=${maxWidthSmall}&h=${relativeHeightSmall}&fit=crop&fm=auto 320w,
            ${image.url}?w=${maxWidthMedium}&h=${relativeHeightMedium}&fit=crop&fm=auto 800w,
            ${image.url}?w=${maxWidthLarge}&h=${relativeHeightLarge}&fit=crop&fm=auto 1400w,
          `}
        src={`${image.url}?w=${maxWidthLarge}&h=${relativeHeightLarge}&fit=crop&fm=auto`}
        alt={image.description}
        loading="lazy"
        width={maxWidthLarge}
        height={relativeHeightLarge}
      />
      {typeof caption !== "undefined" && caption !== "" ? (
        <div className="img__caption">{caption}</div>
      ) : (
        ""
      )}
    </picture>
  );
};

Image.propTypes = {
  image: PropTypes.object,
  caption: PropTypes.string,
  crop: PropTypes.string,
};

export default Image;
